import { activityTypeDetailed } from '@app/pcs/models/activity-type';
import { gql } from 'apollo-angular';

export const deleteActivityTypeTypes = 'deleteActivityType';
export const deleteActivityTypesMutation = gql`
  mutation DeleteActivityType($activityTypeIds: [Long]!) {
    deleteActivityType(activityTypeIds: $activityTypeIds) {
      ...activityTypeDetailed
    }
  }
  ${activityTypeDetailed}
`;

export const copyActivityTypes = 'copyActivityTypes';
export const copyActivityTypesMutation = gql`
  mutation CopyActivityType($activityTypeIds: [Long]!, $ttpId: Long!) {
    copyActivityType(activityTypeIds: $activityTypeIds, ttpId: $ttpId) {
      id
    }
  }
`;

export const saveActivityType = 'saveActivityType';
export const saveActivityTypeMutation = gql`
  mutation SaveActivityType($activityType: ActivityTypeInput!) {
    saveActivityType(activityType: $activityType) {
      id
    }
  }
`;
